export const dnldCampaignSummary = (builder) => ({
    dnldCampaignSummary: builder.mutation({
        query: ({ user_type_id, mode, campaign_id, campaign_name, loggedin_user_id }) => {
            return {
                url: '/downloadChannelCampaignSummaryList',
                method: 'GET',
                params: { user_type_id, mode, campaign_id, campaign_name, loggedin_user_id },
                headers: {
                    'Content-Type': 'text/csv',
                  },
                  responseHandler: (response)=>response.blob(),
            };
        },
    }),
});